export default __webpack_public_path__ + "static/media/system_view2.1549f196.png";